import React, { useState, useEffect } from "react";
import { Button, Input } from "reactstrap";
import Slider from "rc-slider";

const ChatAssessmentField = ({ question, onAnswerChange }) => {
  const [input, setInput] = useState("");

  useEffect(() => {
    const initialValue = getInitialValue(question);
    setInput(initialValue);
  }, [question]);

  // useEffect(() => {
  //   if (onAnswerChange) {
  //     onAnswerChange(input);
  //   }
  // }, [input, onAnswerChange]);

  const handleStyle = {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    cursor: "pointer",
    border: "2px solid #0878ab",
    borderRadius: "3px",
    background: "#0878ab",
    fontSize: "12px",
    textAlign: "center",
    fontWeight: 600,
    zIndex: 3,
    top: 10,
    minWidth: 18,
    color: "#fff",
  };

  const CustomHandle = (props) => {
    const style = Object.assign({ left: props.offset + "%" }, handleStyle);
    return <div style={style}>{props.value}</div>;
  };

  const getInitialValue = (question) => {
    let { answers = [] } = question;

    if (answers.length >= 1) {
      return answers[0].valueInteger?.toString() || "0";
    }

    if (question.initialValue?.valueInteger !== undefined) {
      return question.initialValue.valueInteger.toString();
    }

    return "";
  };

  const handleInputChange = (value) => {
    setInput(value);
    if (onAnswerChange) {
      onAnswerChange(value);
    }
  };

  const handleSliderChange = (value) => {
    setInput(value.toString());
    if (onAnswerChange) {
      onAnswerChange(value.toString());
    }
  };

  const handleChoiceSelect = (option) => {
    setInput(option);
    if (onAnswerChange) {
      onAnswerChange(option);
    }
  };

  const renderQuestionField = (question) => {
    if (question.type === "CHOICE" || question.type === "DISPLAY") {
      return (
        <div className="survey-options-container" aria-label="Survey options">
          <div className="survey-options-wrapper">
            {question.options.map((option, index) => (
              <Button
                key={index}
                className={`btn ${input === option ? "selected" : ""}`}
                color="secondary"
                onClick={() => handleChoiceSelect(option)}
                aria-pressed={input === option}
                aria-label={`Select option: ${option}`}
                tabIndex={0}
              >
                <span className="option-text">{option}</span>
                {input === option && (
                  <span className="sr-only">(Selected)</span>
                )}
              </Button>
            ))}
          </div>
        </div>
      );
    }

    if (question.type === "NUMBER" || question.type === "INTEGER") {
      return (
        <div className="survey-options-container">
          <Input
            type="number"
            value={input}
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              if (!isNaN(value)) {
                handleInputChange(value.toString());
              }
            }}
            onKeyDown={(e) => {
              if (e.key === ".") {
                e.preventDefault();
              }
            }}
            step="1"
            min="0"
            placeholder="Enter a number"
            className="survey-input"
            aria-label="Enter numeric value"
          />
        </div>
      );
    }
    if (question.type === "DECIMAL") {
      return (
        <div className="survey-options-container" aria-label="Numeric input">
          <Input
            type="number"
            value={input}
            onChange={(e) => {
              const value = parseFloat(e.target.value);
              if (!isNaN(value)) {
                handleInputChange(value.toString());
              }
            }}
            placeholder="Enter a decimal number"
            className="survey-input"
            step="0.1"
          />
        </div>
      );
    }

    if (question.type === "CHOICE_WITH_SCALE") {
      const { scale } = question;
      const currentValue = parseInt(input) || scale.minimum;

      return (
        <div className="survey-scale-container">
          <div className="scale-labels d-flex justify-content-between mb-2 mx-2">
            <span className="scale-min">{scale.minimumValueDescription}</span>
            <span className="scale-max">{scale.maximumValueDescription}</span>
          </div>

          <div style={{ margin: "0 1rem" }}>
            <Slider
              min={scale.minimum}
              max={scale.maximum}
              step={scale.step}
              value={currentValue}
              onChange={handleSliderChange}
              handle={CustomHandle}
              trackStyle={{
                background: `linear-gradient(to right, ${scale?.gradientColors?.join(
                  ", "
                )})`,
                height: 8,
              }}
              railStyle={{
                backgroundColor: "#f0f0f0",
                height: 8,
              }}
            />
          </div>
          <div className="scale-values d-flex justify-content-between mt-2 mx-2">
            <span>{scale.minimum}</span>
            <span>{scale.maximum}</span>
          </div>
        </div>
      );
    }
    if (question.type === "DATE") {
      return (
        <div className="survey-options-container">
          <Input
            type="date"
            value={input}
            onChange={(e) => handleInputChange(e.target.value)}
            className="survey-input"
            aria-label="Select a date"
          />
        </div>
      );
    }

    return null;
  };

  return (
    <div className="chat-assessment-field">{renderQuestionField(question)}</div>
  );
};

export default ChatAssessmentField;
